const services = [
  {
    name: "Web Application",
    description: "Craft custom web applications tailored to your business needs. From simple informational websites to complex web-based solutions, we design and develop user-friendly applications that enhance your online presence and drive business growth.",
    image: require("../Service/web.png"),
  },
  { 
    name: "Mobile Application", 
    description: "Turn your ideas into reality with our mobile app development services. Whether you need an app for iOS, Android, or both platforms, our team of experts creates high-quality mobile applications that engage users and deliver exceptional experiences.",
    image: require("../Service/app.png"),
  },
  { 
    name: "Ecommerce Application", 
    description: "Launch your online store and reach customers worldwide with our ecommerce application development. We build scalable and feature-rich ecommerce platforms that empower you to sell products and services seamlessly while maximizing your revenue.",
    image: require("../Service/ecom.png"),
  },
  {
    name: "UI/UX Design",
    description: "Elevate your digital presence with captivating UI/UX design. Our design team combines creativity and usability to craft visually stunning interfaces and intuitive user experiences that resonate with your audience and drive engagement.",
    image: require("../Service/ui_ux.png")
  },
  {
    name: "Digital Marketing",
    description: "Maximize your online reach and grow your business with our digital marketing services. From  (SEO) to social media marketing and pay-per-click (PPC) advertising, we develop tailored strategies to increase your visibility, attract targeted traffic.",
    image: require("../Service/digital_market.png")
  },
  {
    name: "Cloud Solutions",
    description: "Leverage the power of cloud computing to streamline your business operations and drive innovation. Our cloud solutions architects design and implement scalable, secure, and cost-effective cloud infrastructure that enables flexibility, business continuity.",
    image: require("../Service/cloud_solution.png")
  },
  {
    name: "Maintenance & Support",
    description: "Ensure the smooth functioning of your applications with our maintenance and support services. From regular updates and bug fixes to troubleshooting and technical assistance, our dedicated team provides ongoing support to keep your software running optimally.",
    image: require("../Service/maintenance_support.png")
  },
  {
    name: "Consulting Services",
    description: "Gain strategic insights and expert guidance with our consulting services. Whether you need assistance with technology selection, project planning, or digital transformation, our consultants provide valuable advice to help you achieve your business objectives.",
    image: require("../Service/consulting_service.png")
  }
];

export default services;
